import { Box } from "@mui/material";
import { Formik } from "formik";
import * as yup from "yup";
import useMediaQuery from "@mui/material/useMediaQuery";
import ImageInput from "../../components/imageInput";
import TextFieldCompnent from "../../components/textFieldComponent";
import RadioButtonComponent from "../../components/radioButtonComponent";
import ButtonComponent from "../../components/ButtonComponent";
import { useTranslation } from "react-i18next";

const RestaurantForm = ({ buttonText, handleFormSubmit, initialValues, previewImage, setPreviewImage, image, imageId, restaurantId, loading }) => {
    const { t } = useTranslation();
    const isNonMobile = useMediaQuery("(min-width:600px)");
    const restaurantSchema = yup.object().shape({
        name: yup.string().required("Nom est requis"),
        address: yup
            .string()
            .required("L'addresse est requis")
            .test(
                "newlines",
                "Format d'adresse invalide",
                (value) => !value || value.split("\n").length <= 4
            ),
        active: yup.boolean(),
        description: yup.string(),
    });

    return (
        <Formik
            onSubmit={handleFormSubmit}
            initialValues={initialValues}
            validationSchema={restaurantSchema}
        >
            {({
                values,
                errors,
                touched,
                handleBlur,
                handleChange,
                handleSubmit,
            }) => (
                <form onSubmit={handleSubmit}>
                    <Box
                        display="grid"
                        gap="16px"
                        gridTemplateColumns="repeat(6, minmax(0, 1fr))"
                        sx={{
                            "& > div": { gridColumn: isNonMobile ? undefined : "span 6" },
                        }}
                    >
                        <TextFieldCompnent
                            type="text"
                            label={t("fields.name")}
                            change={handleChange}
                            value={values.name}
                            name="name"
                            blur={handleBlur}
                            touched={touched.name}
                            error={errors.name}
                            colum="span 3"
                            row="1 / span 1"
                            required
                        />
                        <TextFieldCompnent
                            multiline
                            maxRows={4}
                            type="text"
                            label={t("fields.address")}
                            change={handleChange}
                            value={values.address}
                            name="address"
                            blur={handleBlur}
                            touched={touched.address}
                            error={errors.address}
                            colum="span 3"
                            row="2 / span 1"
                            required
                        />
                        <TextFieldCompnent
                            type="text"
                            label={t("fields.description")}
                            change={handleChange}
                            value={values.description}
                            name="description"
                            blur={handleBlur}
                            touched={touched.description}
                            error={errors.description}
                            colum="span 3"
                            row="3 / span 1"
                        />
                        <RadioButtonComponent
                            change={handleChange}
                            colum="span 3"
                            row="4 / span 1"
                            name="active"
                            radioText1={t("common.no")}
                            radioText2={t("common.yes")}
                            radioValue1={false}
                            radioValue2={true}
                            text={t("fields.enableRestaurant")}
                            value={values.active}
                        />
                        <ImageInput
                            row="5 / span 1"
                            previewImage={previewImage}
                            setPreviewImage={setPreviewImage}
                            image={image}
                            imageId={imageId}
                            mediaTargetType="Restaurant"
                            mediaRestaurantId={restaurantId || ""}
                        />
                    </Box>
                    <ButtonComponent text={buttonText} loading={loading} />
                </form>
            )}
        </Formik>
    );
};

export default RestaurantForm;
